'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Byline = undefined;

var _themeProvider = require('@spp/theme-provider');

var _Byline = require('./Byline');

var _Byline2 = _interopRequireDefault(_Byline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeProvider.themer)('@spp/ui-byline')(_Byline2.default);
exports.Byline = _Byline2.default;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-byline/lib/cjs/Byline/index.js
 ** module id = 578
 ** module chunks = 1
 **/